import { useState, useMemo } from 'react';
import type { ChatSummary } from '../../../types/index.js';
import type { TabType, TabDefinition } from '../types.js';
import { filterChatsByTab, createTabDefinitions } from '../utils/chatFilters.js';

/**
 * Hook for managing chat filtering and tab logic
 * Handles active tab state and filtered chat list
 */
export const useChatFiltering = (chats: ChatSummary[]) => {
  const [activeTab, setActiveTab] = useState<TabType>('active');

  // Filter chats based on active tab
  const filteredChats = useMemo(
    () => filterChatsByTab(chats, activeTab),
    [chats, activeTab]
  );

  // Create tab definitions with counts
  const tabs = useMemo(
    () => createTabDefinitions(chats),
    [chats]
  );

  return {
    activeTab,
    setActiveTab,
    filteredChats,
    tabs,
  };
};
